import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Recipes",
    date: "05 Aug, 2024",
    admin: "Admin",
    heading: "Top 10 Vegetarian Recipes for Your Next Party",
    important: {
      content: "Impress your guests with our curated selection of vegetarian dishes, perfect for any occasion. Our chef's special recipes bring together fresh ingredients and innovative techniques to create meals that are not only delicious but also visually stunning.",
      intro: "Chef's Special"
    },
    paragraph: {
      para1: "Discover the best vegetarian recipes that are perfect for your next party. From savory appetizers to delicious main courses, these dishes will impress your guests and cater to their dietary preferences. Dive into a world of flavors and creativity with our top picks!",
      para2: "Join us as we explore these mouth-watering recipes, each crafted to bring out the best in vegetarian cuisine. Whether you're hosting a casual get-together or a formal dinner, these recipes will make your event unforgettable.",
      para3: "Unleash the potential of vegetarian cuisine at your next party with our top 10 recipes. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Visualize the delicious vegetarian recipes through our curated gallery. Let these images inspire you to try out these recipes and delight your guests with amazing vegetarian dishes! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Vegetarian", "Party", "Dishes"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Benjamin Alexander",
        date: "Apr 26, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Isabella Grace",
            date: "Apr 28, 2024",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Samuel James",
        date: "Apr 28, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Catering Tips",
    date: "12 July, 2024",
    admin: "Admin",
    heading: "Choosing the Right Menu for a Wedding Reception",
    important: {
      content: "A well-planned wedding menu sets the tone for your celebration and reflects your personal taste. From elegant plated meals to diverse buffet spreads, selecting the perfect dishes ensures an unforgettable dining experience for your guests.",
      intro: "Wedding Catering Expert"
    },
    paragraph: {
      para1: "Planning a wedding menu involves more than just picking your favorite dishes. You need to consider guest preferences, dietary restrictions, and the overall vibe of your event. A thoughtful selection of appetizers, entrees, and desserts can elevate your reception to a culinary celebration.",
      para2: "Whether you’re going for a traditional sit-down meal or a modern food truck vibe, the key is balance—flavor, presentation, and pacing matter. Seasonal ingredients and local specialties can also add a personalized touch to the menu.",
      para3: "Don’t forget about vegetarian, vegan, and gluten-free options to accommodate all your guests. Coordinating with your caterer well in advance helps to create a seamless flow for the event while ensuring quality and service.",
      para4: "Explore stunning visuals of expertly curated wedding menus and setups in our gallery. Let these images inspire your choices and help you envision the perfect dining experience for your big day."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Wedding", "Dishes", "Creative"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Emily Rose",
        date: "July 15, 2024",
        content: "This guide really helped us refine our wedding menu. Loved the tips on including seasonal ingredients!",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Oliver Stone",
            date: "July 16, 2024",
            content: "Totally agree! Our guests loved the fresh summer dishes we served thanks to this advice."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Liam Carter",
        date: "July 18, 2024",
        content: "We went with a fusion menu based on this post—great inspiration and very practical."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Restaurant Reviews",
    date: "18 March, 2025",
    admin: "Admin",
    heading: "Top 5 Restaurants to Visit in Your City",
    important: {
      content: "Discover a curated list of must-visit restaurants in your city, featuring diverse cuisines, unforgettable atmospheres, and culinary excellence. Whether you're a local foodie or just passing through, these spots promise a memorable dining experience.",
      intro: "Local Food Critic"
    },
    paragraph: {
      para1: "Your city is home to some incredible culinary gems. From upscale dining experiences to cozy hidden cafes, this list showcases restaurants that stand out for their menu, service, and ambiance.",
      para2: "Each restaurant was selected based on food quality, unique offerings, customer reviews, and atmosphere. Whether you're looking for gourmet meals, authentic international cuisine, or innovative dishes, there's something here for every palate.",
      para3: "Many of these restaurants also focus on sustainability and sourcing local ingredients, ensuring freshness and community support. Don't forget to check if reservations are needed—these spots are often in high demand!",
      para4: "Browse through our gallery to get a taste of what these top restaurants offer. From beautiful interiors to artfully plated meals, you'll be inspired to plan your next culinary outing."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Restaurants", "Dishes", "Creative"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Chloe Bennett",
        date: "March 20, 2025",
        content: "Tried two of these places over the weekend—both were fantastic! Thanks for the recommendations.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Ryan Harper",
            date: "March 21, 2025",
            content: "Same here! The rooftop dining spot was a highlight. Great list!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Ava Martinez",
        date: "March 22, 2025",
        content: "This blog convinced me to explore more local restaurants. Keep these guides coming!"
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Food Trends",
    date: "02 April, 2025",
    admin: "Admin",
    heading: "The Rise of Plant-Based Menus in Restaurants",
    important: {
      content: "More restaurants are embracing plant-based options, reflecting the shift toward sustainable, health-conscious dining. This trend isn’t just a fad—it’s a culinary evolution that’s reshaping how chefs design menus and how consumers experience food.",
      intro: "Sustainable Food Expert"
    },
    paragraph: {
      para1: "As dietary preferences evolve, the demand for plant-based options is reshaping the restaurant industry. Chefs are getting more creative with vegetables, legumes, and plant proteins, making plant-based dishes as indulgent and flavorful as their meat-based counterparts.",
      para2: "Plant-based dining isn't only for vegans. It appeals to health-conscious individuals, environmentally-aware consumers, and anyone seeking variety. Many restaurants now dedicate entire sections of their menu—or the entire menu—to plant-based fare.",
      para3: "This trend is also driven by sustainability goals. Using fewer animal products helps reduce environmental impact, and sourcing locally grown produce supports the community and enhances freshness.",
      para4: "Take a visual journey through our curated gallery to see beautifully presented plant-based dishes that are as satisfying to look at as they are to eat. These images highlight the creativity and richness of the plant-based culinary movement."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Plant-Based", "Restaurants", "Dishes"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Liam Roberts",
        date: "April 3, 2025",
        content: "I’ve noticed more plant-based options lately and they’re honestly amazing. This article is spot on!",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Emily Zhang",
            date: "April 4, 2025",
            content: "Yes! I’ve even converted some of my meat-loving friends with these dishes."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Noah Lee",
        date: "April 5, 2025",
        content: "Great insights! It’s encouraging to see restaurants moving in this direction."
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Behind the Scenes",
    date: "05 April, 2025",
    admin: "Admin",
    heading: "The Creative Process Behind Our Signature Dishes",
    important: {
      content: "Our signature dishes are more than just recipes—they’re a fusion of passion, experimentation, and culinary artistry. Discover how each plate comes to life through an intricate process of inspiration, refinement, and storytelling.",
      intro: "Head Chef’s Note"
    },
    paragraph: {
      para1: "Creating a signature dish starts with inspiration—be it a seasonal ingredient, a childhood memory, or an unexpected flavor pairing. Our chefs explore, taste, and refine ideas until they find something truly special.",
      para2: "Once the concept is clear, we move into experimentation: testing combinations, adjusting seasoning, and layering textures to craft a dish that balances innovation with familiarity.",
      para3: "Presentation is just as important as taste. Every plate is designed to engage the senses, from vibrant colors to elegant plating techniques that tell a story at first glance.",
      para4: "Browse our exclusive gallery showcasing some of our most iconic dishes and the journey behind them. These creations are a testament to the creativity, effort, and emotion poured into every bite."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Creative", "Signature", "Dishes"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Chloe Bennett",
        date: "April 6, 2025",
        content: "It’s fascinating to learn what goes into creating these incredible dishes. Truly inspiring!",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Jackson Cruz",
            date: "April 6, 2025",
            content: "Totally agree. Makes me appreciate my meals even more."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Ava Thompson",
        date: "April 7, 2025",
        content: "Loved the gallery! The plating alone deserves awards."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Recipes",
    date: "08 April, 2025",
    admin: "Admin",
    heading: "Signature Sauces to Elevate Your Dishes",
    important: {
      content: "A great sauce can transform a simple dish into a culinary masterpiece. From bold reductions to creamy emulsions, our signature sauces are designed to bring flavor, balance, and elegance to every plate.",
      intro: "Culinary Director's Insight"
    },
    paragraph: {
      para1: "Sauces are often the unsung heroes of gourmet cuisine. They bring richness, complexity, and cohesion to the components on a plate. In this guide, we explore our most beloved sauces and the techniques behind them.",
      para2: "From a classic béarnaise to a smoky chipotle aioli, each sauce is crafted with precision. The process involves choosing quality ingredients, understanding emulsification, and layering flavors to create depth.",
      para3: "Pairing the right sauce with the right dish is both an art and a science. Whether you're cooking meat, vegetables, or pasta, there's a signature sauce that can take your meal to the next level.",
      para4: "Dive into our gallery to see our sauces in action—beautifully drizzled, artfully plated, and ready to inspire your next kitchen creation."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Signature", "Dishes", "Creative"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Ethan Clarke",
        date: "April 9, 2025",
        content: "These sauce tips are a game changer. Tried the red wine reduction and it was amazing!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Olivia Harper",
            date: "April 9, 2025",
            content: "Same! It added so much depth to my steak dish."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Liam Foster",
        date: "April 10, 2025",
        content: "This post helped me finally nail my hollandaise sauce. Thank you!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Recipes",
    date: "05 August, 2024",
    admin: "Admin",
    heading: "10 Delicious Vegetarian Dishes Perfect for Your Next Party",
    important: {
      content: "Impress your guests with our curated selection of vegetarian dishes, perfect for any occasion. Our chef's special recipes bring together fresh ingredients and innovative techniques to create meals that are not only delicious but also visually stunning.",
      intro: "Chef's Special"
    },
    paragraph: {
      para1: "Discover the best vegetarian recipes that are perfect for your next party. From savory appetizers to delicious main courses, these dishes will impress your guests and cater to their dietary preferences. Dive into a world of flavors and creativity with our top picks!",
      para2: "Join us as we explore these mouth-watering recipes, each crafted to bring out the best in vegetarian cuisine. Whether you're hosting a casual get-together or a formal dinner, these recipes will make your event unforgettable.",
      para3: "Unleash the potential of vegetarian cuisine at your next party with our top 10 recipes. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Visualize the delicious vegetarian recipes through our curated gallery. Let these images inspire you to try out these recipes and delight your guests with amazing vegetarian dishes! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Vegetarian", "Party", "Dishes"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Benjamin Alexander",
        date: "26 April, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Isabella Grace",
            date: "28 April, 2024",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Samuel James",
        date: "28 April, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Catering Tips",
    date: "08 April, 2025",
    admin: "Admin",
    heading: "How to Select the Perfect Menu for a Wedding Reception",
    important: {
      content: "Crafting the ideal wedding reception menu involves balancing personal taste with guest satisfaction, seasonal availability, and venue limitations. Let our planning guide help you create a dining experience that’s both memorable and meaningful.",
      intro: "Wedding Menu Expert"
    },
    paragraph: {
      para1: "Planning a wedding menu is one of the most exciting yet challenging parts of organizing a reception. It sets the tone for the celebration and leaves a lasting impression on your guests.",
      para2: "This guide will walk you through choosing dishes that reflect your personal taste while also accommodating dietary restrictions, themes, and local seasonal ingredients.",
      para3: "From hors d’oeuvres to dessert stations, learn how to design a cohesive menu that complements the flow of your event and satisfies a diverse palate.",
      para4: "Take inspiration from real wedding menus and curated examples that blend tradition with creativity, ensuring your guests enjoy a delightful culinary experience."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Wedding", "Dishes", "Creative"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Olivia Morgan",
        date: "10 April, 2025",
        content: "This is exactly what I needed! Planning our wedding menu felt overwhelming, but your tips helped narrow down the options beautifully."
      },
      {
        id: 2,
        image: images.blog8Comment2,
        name: "Daniel Reed",
        date: "11 April, 2025",
        content: "Great insights on seasonal ingredients! It really helped us make more sustainable choices for our reception."
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Restaurant Reviews",
    date: "12 April, 2025",
    admin: "Admin",
    heading: "5 Must-Visit Restaurants in Your City",
    important: {
      content: "Experience the culinary heart of your city with these five standout restaurants. Whether you're a local foodie or a curious traveler, these destinations offer unforgettable flavors and atmospheres that define the local dining scene.",
      intro: "Local Food Critic"
    },
    paragraph: {
      para1: "Your city is home to a diverse culinary landscape, filled with hidden gems and acclaimed dining establishments that are sure to impress any palate.",
      para2: "In this guide, we spotlight five exceptional restaurants known for their ambiance, innovation, and outstanding flavors—from trendy bistros to historic eateries.",
      para3: "Each venue offers something unique: locally sourced ingredients, fusion dishes, and masterfully curated menus that capture the spirit of the neighborhood.",
      para4: "Explore our gallery to get a visual taste of each location before you plan your next dining adventure. These places aren’t just meals—they’re experiences."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Restaurants", "Dishes", "Creative"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Elena Thomas",
        date: "13 April, 2025",
        content: "I’ve been to two of these places and they’re amazing! Can’t wait to try the others on the list."
      },
      {
        id: 2,
        image: images.blog9Comment2,
        name: "Marcus Lane",
        date: "14 April, 2025",
        content: "Love this guide! Always looking for new local spots to enjoy with friends."
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Food Trends",
    date: "15 April, 2025",
    admin: "Admin",
    heading: "The Growing Popularity of Plant-Based Menus in Restaurants",
    important: {
      content: "Plant-based dining is transforming the restaurant scene, offering innovative and sustainable options that cater to both health-conscious eaters and environmental advocates.",
      intro: "Culinary Trend Analyst"
    },
    paragraph: {
      para1: "Across the globe, restaurants are increasingly adopting plant-based menus to meet the growing demand for healthier, eco-friendly dining options.",
      para2: "This shift isn't just about replacing meat—it's about celebrating vegetables, legumes, grains, and plant-based proteins in new and exciting ways.",
      para3: "Top chefs are pushing creative boundaries, developing plant-based dishes that rival traditional favorites in flavor and presentation.",
      para4: "Take a look at some standout examples of plant-based creations in our gallery, and see how restaurants are redefining modern cuisine one plate at a time."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Plant-Based", "Restaurants", "Dishes"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Liam Carter",
        date: "16 April, 2025",
        content: "As a vegan, it’s exciting to see more restaurants embracing this trend with creative options!"
      },
      {
        id: 2,
        image: images.blog10Comment2,
        name: "Sophia Bennett",
        date: "17 April, 2025",
        content: "I love how plant-based menus are no longer boring. These dishes are truly gourmet."
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Behind the Scenes",
    date: "18 April, 2025",
    admin: "Admin",
    heading: "The Art Behind Crafting Our Signature Dishes",
    important: {
      content: "Creating signature dishes is a blend of passion, precision, and innovation. Our chefs combine years of experience and creativity to craft unforgettable flavors.",
      intro: "Executive Chef"
    },
    paragraph: {
      para1: "Each signature dish we create is a masterpiece that reflects the heart and soul of our culinary team. From selecting the finest ingredients to perfecting presentation, every detail matters.",
      para2: "Our chefs experiment with various textures, techniques, and flavors to craft dishes that not only taste incredible but also provide a visual feast for the eyes.",
      para3: "Signature dishes often carry a story, whether it's a nod to a cultural heritage or an innovative twist on a classic recipe.",
      para4: "Explore our gallery to get a behind-the-scenes look at the creative process, from ingredient selection to plating, and discover the passion that goes into each dish."
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2
    ],
    tags: ["Creative", "Signature", "Dishes"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Olivia Martinez",
        date: "19 April, 2025",
        content: "I’m fascinated by how much thought goes into creating a signature dish. It truly is an art form!"
      },
      {
        id: 2,
        image: images.blog11Comment2,
        name: "Lucas Robinson",
        date: "20 April, 2025",
        content: "This blog makes me appreciate food even more. The creativity involved is remarkable."
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "Recipes",
    date: "25 April, 2025",
    admin: "Admin",
    heading: "How Signature Sauces Can Enhance Your Meals",
    important: {
      content: "A signature sauce can transform any meal from ordinary to extraordinary. Learn how these flavorful additions elevate your culinary creations.",
      intro: "Sauce Specialist"
    },
    paragraph: {
      para1: "Signature sauces are often the hidden gem that enhances the overall flavor of a dish. Whether it’s a rich, creamy sauce or a tangy vinaigrette, these sauces bring out the best in your ingredients.",
      para2: "From balancing flavors to adding texture and complexity, the right sauce can completely alter the eating experience, making each bite more exciting.",
      para3: "Creating a signature sauce involves choosing the perfect base, incorporating complementary ingredients, and adding that personal touch that makes it unique to your dish or restaurant.",
      para4: "Explore our sauce collection to find out how each one complements different meals, from grilled meats to fresh salads, and learn the art of pairing sauces with the right dishes."
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2
    ],
    tags: ["Signature", "Dishes", "Creative"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Lily Thompson",
        date: "26 April, 2025",
        content: "I never realized how important sauces were until I read this! Can’t wait to try some new recipes with signature sauces."
      },
      {
        id: 2,
        image: images.blog12Comment2,
        name: "James Carter",
        date: "27 April, 2025",
        content: "This blog makes me want to experiment with different sauces. The right sauce truly makes a difference."
      }
    ]
  }

];

export default blogs;